import { render, staticRenderFns } from "./PostNotConfirmed.vue?vue&type=template&id=c9da173c&scoped=true&"
import script from "./PostNotConfirmed.vue?vue&type=script&lang=js&"
export * from "./PostNotConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9da173c",
  null
  
)

export default component.exports